// ===========================================
// Parcoursup — Constants
// ===========================================
// Faculty catalogue (FAC_CATALOGUE, FAC_MAPPING, FAC_BY_LABEL) is now
// DB-driven via the useFacsCatalogue hook in hooks/useFacsCatalogue.js

// Status enums
export const PARCOURSUP_STATUS = {
	INTERESSE: 'interesse',
	VAINSCRIT: 'vainscrit',
	HESITE: 'hesite',
	PASINTERESSE: 'pasinteresse',
	INSCRITCONCURRENCE: 'inscritconcurrence',
	ARAPPELER: 'arappeler',
	TRAITE: 'traite',
}

export const PARCOURSUP_STATUS_LABELS = {
	interesse: 'Intéressé',
	vainscrit: "Va s'inscrire",
	hesite: 'Hésitant',
	pasinteresse: 'Pas intéressé',
	inscritconcurrence: 'Inscrit concurrence',
	arappeler: 'A rappeler',
	traite: 'Traité',
}

export const START_STATUS = {
	A_APPELER: 'a_appeler',
	A_RAPPELER_START: 'a_rappeler_start',
	VALIDE_START: 'valide_start',
}

export const START_STATUS_LABELS = {
	a_appeler: 'A appeler',
	a_rappeler_start: 'A rappeler START',
	valide_start: 'Validé START',
}

export const VOEU_STATUS = {
	PRIS: 'pris',
	ATTEIGNABLE: 'atteignable',
	INCERTAIN: 'incertain',
	HORS_PORTEE: 'hors_portee',
	EN_ATTENTE: 'en_attente',
}

export const CATEGORY = {
	URGENT: 'urgent',
	WATCH: 'watch',
	WAIT: 'wait',
	LOW: 'low',
}

export const CATEGORY_LABELS = {
	urgent: 'Urgent',
	watch: 'A surveiller',
	wait: 'En attente',
	low: 'Faible priorité',
}

export const COMPLETUDE = {
	COMPLET: 'complet',
	PARTIEL: 'partiel',
	INCOMPLET: 'incomplet',
}

export const INSCRIT_CLAIM = {
	PENDING: 'pending',
	REJECTED: 'rejected',
	CONFIRMED: 'confirmed',
}

export const REGLE_APPLIQUEE = {
	SAME: 'same',
	ORIGINE: 'origine',
	MINEURE: 'mineure',
	REASSIGN: 'reassign',
	FALLBACK: 'fallback',
	VSQ_DIRECT: 'vsq_direct',
}

export const VSQ_FACULTY_LABEL = 'Versailles Saint-Quentin'

export const MAX_START_ATTEMPTS = 5
export const MAX_STATUS_HISTORY = 20
